import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";

class ImageGalleryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: this.props.startIndex || 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ selectedIndex: this.props.startIndex || 0 });
    }
  }

  handleNext = () => {
    const { images } = this.props;
    this.setState((prevState) => ({
      selectedIndex: (prevState.selectedIndex + 1) % images.length,
    }));
  };

  handlePrev = () => {
    const { images } = this.props;
    this.setState((prevState) => ({
      selectedIndex:
        (prevState.selectedIndex - 1 + images.length) % images.length,
    }));
  };

  render() {
    const { isOpen, onClose, images, isLaptop } = this.props;
    const { selectedIndex } = this.state;

    if (!images || images.length === 0) return null;

    return (
      <Modal isOpen={isOpen} toggle={onClose} size="lg" fullscreen>
        <ModalBody
          className="d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "black",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              left: "30px",
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "40px",
              fontWeight: "light",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            ×
            <span style={{ fontSize: "21px", marginLeft: "10px", marginTop: "5px" }}>
              Close
            </span>
          </button>

          {/* Counter */}
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              color: "white",
              fontSize: "21px",
              fontWeight: "light",
              background: "rgba(0, 0, 0, 0.5)",
              padding: "5px 10px",
              borderRadius: "8px",
            }}
          >
            {selectedIndex + 1} / {images.length}
          </div>

          {/* Image */}
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={images[selectedIndex]}
              alt="Preview"
              style={{
                width: isLaptop ? "100%" : "70%",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Navigation Arrows */}
          {images.length > 1 && (
            <>
              <button onClick={this.handlePrev} style={arrowBtnStyle("left")}>
                {"<"}
              </button>
              <button onClick={this.handleNext} style={arrowBtnStyle("right")}>
                {">"}
              </button>
            </>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

// Arrow button styles
const arrowBtnStyle = (side) => ({
  position: "absolute",
  [side]: "2%",
  top: "50%",
  transform: "translateY(-50%)",
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  border: "2px solid rgba(255, 255, 255, 0.6)",
  background: "rgba(0, 0, 0, 0.5)",
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "24px",
  cursor: "pointer",
  zIndex: 10,
});

export default ImageGalleryModal;
